import './styles/LanguageSelection.scss';
import './styles/LoginSelection.scss';

import { Grid, Icon, Paper, useMediaQuery } from '@mui/material';

import qs from 'qs';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { LanguagePicker } from 'app/components/LanguagePicker';
import { Modal } from 'app/components/Modal';
import Placeholder from 'assets/placeholder.svg';
import { translations } from 'locales/i18n';

import Register from './Register';
import { CompanyLoginModal } from './login/CompanyLogin';
import { DeveloperLoginModal } from './login/DeveloperLogin';
import { IOLoginModal } from './login/IOLogin';

export function LoginSelection() {
  const { t } = useTranslation();

  const location = useLocation();
  const searchParams = qs.parse(location.search, { ignoreQueryPrefix: true }).view;
  const companyModalOpen = () => {
    if (searchParams === 'company-register') {
      return true;
    }
    return false;
  };

  const [ioLoginOpen, setIOLoginOpen] = useState(false);
  const [companyLoginOpen, setCompanyLoginOpen] = useState(companyModalOpen());
  // const openCompanyLogin = view === 'company-register' ? true : false;
  const [developerLoginOpen, setDeveloperLoginOpen] = useState(false);

  const [registerModalOpen, setRegisterModalOpen] = useState(false);
  const [disabledCancel, setDisabledCancel] = useState(false);
  const smallerThanMd = useMediaQuery((theme: any) => theme.breakpoints.down('md'));

  const handleUniversityLogin = () => {
    if (import.meta.env.VITE_NODE_ENV === 'production' && !import.meta.env.VITE_IS_STAGING) {
      window.location.href = 'https://dashboard.th-rosenheim.de/Shibboleth.sso/login';
    } else if (import.meta.env.VITE_IS_STAGING) {
      window.location.href = import.meta.env.VITE_SHIB_LOGIN_URL!;
    } else {
      console.log('No shib login in local setup');
    }
  };

  const ArrowIcon = () => (
    <Icon
      className="fas fa-arrow-alt-circle-right fa-4x"
      color="primary"
      style={{
        width: 'auto'
      }}
    />
  );

  const UniversityLogin = () => {
    return (
      <Grid
        className="loginContainer__card__login"
        container
        component={Paper}
        onClick={() => handleUniversityLogin()}
        sx={{ padding: { xs: '1em', lg: '3.5em 3em' } }}
      >
        <Grid
          className="loginContainer__card__login__icon"
          item
          xs={12}
          md={3}
          justifyContent={'space-between'}
          sx={{ paddingBottom: { xs: '0.5em', md: null } }}
        >
          <Icon
            className="fas fa-users fa-4x"
            style={{
              width: 'auto'
            }}
          />
          {smallerThanMd && <ArrowIcon />}
        </Grid>
        <Grid item xs={12} lg={7}>
          <Grid container>
            <Grid className="loginContainer__card__login__headline" item xs={12}>
              {t(translations.pages.login.loginSelection.universityLogin.title()).toUpperCase()}
            </Grid>
            <Grid item xs={12}>
              {t(translations.pages.login.loginSelection.universityLogin.description())}
            </Grid>
          </Grid>
        </Grid>
        {!smallerThanMd && (
          <Grid className="loginContainer__card__login__arrow" item xs={12} lg={2}>
            <ArrowIcon />
          </Grid>
        )}
      </Grid>
    );
  };

  const InternationalOfficeLogin = () => {
    return (
      <Grid
        className="loginContainer__card__login"
        container
        component={Paper}
        onClick={() => setIOLoginOpen(true)}
        sx={{ padding: { xs: '1em', lg: '3.5em 3em' } }}
      >
        <Grid
          className="loginContainer__card__login__icon"
          item
          xs={12}
          md={3}
          justifyContent={'space-between'}
          sx={{ paddingBottom: { xs: '0.5em', md: null } }}
        >
          <Icon
            className="fas fa-globe-africa fa-4x"
            style={{
              width: 'auto'
            }}
          />
          {smallerThanMd && <ArrowIcon />}
        </Grid>
        <Grid item xs={12} lg={7}>
          <Grid container>
            <Grid className="loginContainer__card__login__headline" item xs={12}>
              {t(
                translations.pages.login.loginSelection.internationalOfficeLogin.title()
              ).toUpperCase()}
            </Grid>
            <Grid item xs={12}>
              {t(translations.pages.login.loginSelection.internationalOfficeLogin.description())}
            </Grid>
          </Grid>
        </Grid>
        {!smallerThanMd && (
          <Grid className="loginContainer__card__login__arrow" item xs={12} lg={2}>
            <ArrowIcon />
          </Grid>
        )}
      </Grid>
    );
  };

  const CompanyLogin = () => {
    return (
      <Grid
        className="loginContainer__card__login"
        container
        component={Paper}
        onClick={() => setCompanyLoginOpen(true)}
        sx={{ padding: { xs: '1em', lg: '3.5em 3em' } }}
      >
        <Grid
          className="loginContainer__card__login__icon"
          item
          xs={12}
          md={3}
          justifyContent={'space-between'}
          sx={{ paddingBottom: { xs: '0.5em', md: null } }}
        >
          <img src={Placeholder} style={{ maxHeight: `70px` }} alt="no logo" />
          {smallerThanMd && <ArrowIcon />}
        </Grid>
        <Grid item xs={12} lg={7}>
          <Grid container>
            <Grid className="loginContainer__card__login__headline" item xs={12}>
              {t(translations.pages.login.loginSelection.companyLogin.title()).toUpperCase()}
            </Grid>
            <Grid item xs={12}>
              {t(translations.pages.login.loginSelection.companyLogin.description())}
            </Grid>
          </Grid>
        </Grid>
        {!smallerThanMd && (
          <Grid className="loginContainer__card__login__arrow" item xs={12} lg={2}>
            <ArrowIcon />
          </Grid>
        )}
      </Grid>
    );
  };

  const DeveloperLogin = () => {
    return (
      <Grid
        className="loginContainer__card__login"
        container
        component={Paper}
        onClick={() => setDeveloperLoginOpen(true)}
        sx={{ padding: { xs: '1em', lg: '3.5em 3em' } }}
      >
        <Grid
          className="loginContainer__card__login__icon"
          item
          xs={12}
          md={3}
          justifyContent={'space-between'}
          sx={{ paddingBottom: { xs: '0.5em', md: null } }}
        >
          <Icon
            className="fas fa-cog fa-4x"
            style={{
              width: 'auto'
            }}
          />
          {smallerThanMd && <ArrowIcon />}
        </Grid>
        <Grid item xs={12} lg={7}>
          <Grid container>
            <Grid className="loginContainer__card__login__headline" item xs={12}>
              {t(translations.pages.login.loginSelection.developerLogin.title()).toUpperCase()}
            </Grid>
            <Grid item xs={12}>
              {t(translations.pages.login.loginSelection.developerLogin.description())}
            </Grid>
          </Grid>
        </Grid>
        {!smallerThanMd && (
          <Grid className="loginContainer__card__login__arrow" item xs={12} lg={2}>
            <ArrowIcon />
          </Grid>
        )}
      </Grid>
    );
  };

  const cancelRegistration = (event?, reason?) => {
    if (reason && reason === 'backdropClick') return;
    if (disabledCancel) {
      return;
    }
    setDisabledCancel(true);
    setRegisterModalOpen(false);
    setDisabledCancel(false);
  };

  return (
    <>
      <Modal
        open={registerModalOpen}
        onClose={cancelRegistration}
        width="half"
        headline={t(translations.pages.login.registerTitle())}
        onCancel={() => {
          cancelRegistration();
        }}
        disabledCancel={disabledCancel}
      >
        <Register
          onCancel={() => {
            setRegisterModalOpen(false);
          }}
          setDisabledCancel={setDisabledCancel}
        />
      </Modal>
      <Modal
        width="small"
        open={ioLoginOpen}
        onClose={() => setIOLoginOpen(false)}
        onCancel={() => setIOLoginOpen(false)}
      >
        <IOLoginModal closeHandler={() => setIOLoginOpen(false)} />
      </Modal>
      <Modal
        width="small"
        open={companyLoginOpen}
        onClose={() => setCompanyLoginOpen(false)}
        onCancel={() => setCompanyLoginOpen(false)}
      >
        <CompanyLoginModal
          setRegisterModalOpen={setRegisterModalOpen}
          closeHandler={() => setCompanyLoginOpen(false)}
        />
      </Modal>
      <Modal
        open={developerLoginOpen}
        onClose={() => setDeveloperLoginOpen(false)}
        onCancel={() => setDeveloperLoginOpen(false)}
      >
        <DeveloperLoginModal closeHandler={() => setDeveloperLoginOpen(false)} />
      </Modal>
      <div className="language-select">
        <LanguagePicker />
      </div>
      <Grid container className="loginContainer">
        <Grid container className="loginContainer__wrapper" item xs={11} md={10} lg={8} gap={2}>
          <UniversityLogin />
          <InternationalOfficeLogin />
          <CompanyLogin />
          {(import.meta.env.VITE_NODE_ENV !== 'production' || import.meta.env.VITE_IS_STAGING) && (
            <DeveloperLogin />
          )}
        </Grid>
      </Grid>
    </>
  );
}
